"use client";

import { useEffect } from "react";
import { trackComparisonView } from "./ga-events";

export function TrackComparisonView({ comparisonType }: { comparisonType: string }) {
  useEffect(() => {
    trackComparisonView(comparisonType);
  }, [comparisonType]);

  return null;
}
